module.exports = __webpack_public_path__ + "img/ordertit_Img.7d2feb3b.jpg";